import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { ICmsUtilViewContainerDirective } from '@icms/core/util/view-container/icms-util-view-container.directive';
import { NICmsNotification } from '../icms-notification.interfaces';
import { ICmsNotificationItemComponent } from '../item/icms-notification-item.component';

@Component({
    standalone: false,
    selector: 'icms-notification-area',
    template: '<ng-template iCmsUtilViewContainer></ng-template>',
    styleUrls: ['icms-notification-area.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ICmsNotificationAreaComponent {
    @ViewChild(ICmsUtilViewContainerDirective, { static: true })
    viewContainerTemplate!: ICmsUtilViewContainerDirective;

    add(data: NICmsNotification.IData) {
        const viewContainerRef = this.viewContainerTemplate.viewContainerRef;
        const componentRef = viewContainerRef.createComponent<ICmsNotificationItemComponent>(ICmsNotificationItemComponent);
        componentRef.instance.data = data;
        componentRef.instance.componentRef = componentRef;
        componentRef.changeDetectorRef.detectChanges();
    }
}
